import React, { useState } from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import { Button } from 'components/Button';
import './index.sass';

const { block, el } = bem('show-more');
export const ShowMore = ({children, showMoreButtonText = 'Загрузить ещё', step = 99}) => {

    const [ show, setShow ] = useState(2);

    const onClick = () => {
        setShow( oldShow => {
            return oldShow + step;
        })
    }

    return (
        <>
            {React.Children.toArray( children ).slice( 0, show )}
            {show < React.Children.count( children ) &&
                <Button className={block()} mod={['transparent-gold']} onClick={onClick}>
                    <Text>{showMoreButtonText}</Text>
                </Button>}
        </>
    )
}
